import { html, renderIf, LitEntity, SirenActionMixin } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-icon';

class DeviceSnoozeFlagButton extends SirenActionMixin(LitEntity) {
  static get properties() {
    return {
      flagname: { type: String },
      updateAction: { type: Object, attribute: false },
      visibility: { type: String, attribute: false },
    };
  }

  static get styles() {
    return sharedStyles;
  }

  render() {
    if (!this.flagname || !this.entity) {
      return html``;
    }

    return html`
      <button
        title="${this.visibility === 'visible' ? 'Snooze' : 'Un-snooze'}"
        class="button button--contained"
        @click="${this._toggleSnooze}"
        ?disabled="${!this.updateAction || this.loading}"
      >
        ${renderIf(this.visibility === 'visible', html`
          <bn-icon name="far fa-snooze"></bn-icon>
        `)}
        ${renderIf(this.visibility === 'snooze', html`
          <bn-icon name="far fa-alarm-exclamation"></bn-icon>
        `)}
      </button>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity || !this.flagname) {
      return;
    }

    const flag = this.entity.getSubEntityByClass(this.flagname);
    if (!flag) {
      return;
    }

    this.updateAction = flag.getActionByName('update-visibility');
    this.visibility = flag.properties.visibility;
  }

  async _toggleSnooze() {
    if (!this.updateAction) {
      return;
    }

    try {
      const preFlag = this.entity.getSubEntityByClass(this.flagname);
      this.dispatchEvent(new CustomEvent('togglesnooze', { detail: { entity: preFlag }, bubbles: true, composed: true }));

      this.loading = true;
      const fields = this.getActionFields(this.updateAction);
      const targetVisibility = this.visibility === 'visible' ? 'snooze' : 'visible';
      fields.set('visibility', targetVisibility);
      const { entity, error } = await this.submitAction(this.updateAction, fields);
      this.loading = false;
      if (error) {
        this.dispatchEvent(new ErrorEvent('error', { error }));
        return;
      }

      const flag = entity.getSubEntityByClass(this.flagname);
      this.dispatchEvent(new CustomEvent('update', { detail: { entity: flag }, bubbles: true, composed: true }));
    } catch (error) {
      this.loading = false;
      this.dispatchEvent(new ErrorEvent('error', { error }));
    }
  }
}

window.customElements.define('device-snooze-flag-button', DeviceSnoozeFlagButton);
